<template>
	<div class="login-page">
		<!-- 学生学习平台 -->
		<div class="login-wrap">
			
			<!-- 账号密码登录 -->
			<div class="login-ctn bg2" v-show="!isScanEwm">
				<img class="logo" style="top:40px; left:60px;" src="../../static/img/login/login-logo.png" alt="">
				<div class="log-form">
					<div class="log-title">学生学习平台</div>
					<div class="item" :class="{focus:userFocus||userName}">
						<input class="input" type="text" placeholder="请输入登录账号" v-model="userName"
							@focus="focusInput('userFocus')" @blur="blurInput('userFocus')">
						<i class="ico log-user"></i>
					</div>
					<div class="item" :class="{focus:passwordFocus||password}">
						<input class="input" type="password" placeholder="请输入登录密码" v-model="password"
							@focus="focusInput('passwordFocus')" @blur="blurInput('passwordFocus')">
						<i class="ico log-psw" ></i>
					</div>
					<div class="item code-box" :class="{focus:codeFocus||code}">
						<div class="code-img"></div>
						<input class="input" type="text" placeholder="请输入验证码" v-model="code"
							@focus="focusInput('codeFocus')" @blur="blurInput('codeFocus')">
						<i class="ico log-code"></i>
					</div>
					<div class="submit-btn">登录</div>
					<div class="forget-btn">
						<a href="javascript:;">立即注册</a>
						<a href="javascript:;">忘记密码</a>
					</div>
				</div>
				<img class="ewm-btn" @click="changeLoginType" src="../../static/img/login/ewm-btn.png" alt="">
			</div>
			
			<!-- 二维码登录 -->
			<div class="login-ctn bg3" v-show="isScanEwm">
				<img class="ytykt-logo" src="../../static/img/login/ytykt-logo.png" alt="">
				<img class="ytksy-logo" src="../../static/img/login/ytksy-logo.png" alt="">
				<div class="scan-code">
					<h3>APP扫码登录</h3>
					<div class="tip">使用【绎通云课堂APP】扫一扫登录</div>
					<div class="ewm">
						<img class="ewm-img" src="../../static/img/login/ewm.png" alt="">
					</div>
					<div class="tip2">还未下载安装【绎通云课堂APP】？请点右侧下载</div>
				</div>
				<img class="ewm-btn" @click="changeLoginType" src="../../static/img/login/pc-btn.png" alt="">
			</div>
			<div class="copyright">Copyright 2022-现在 中国教育技术协会网络课程建设工作委员会    粤ICP备XXXXXXXX号-1</div>
		</div>
		
	</div>
</template>

<script>
export default {
	name: 'login',
	components:{

	},
	data () {
		return {
			userFocus:false,
			passwordFocus:false,
			codeFocus:false,
			userName:'',
			password:'',
			code:'',
			
			isScanEwm:false,	//是否二维码登录
		}
	},
	
	created(){
		
	},
  
	computed:{
		
	},
  
	methods:{
		focusInput(key){
			this[key] = true
		},
		blurInput(key){
			this[key] = false
		},
		changeLoginType(){
			this.isScanEwm = !this.isScanEwm
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/static/css/login.less';
</style>



// WEBPACK FOOTER //
// src/pages/login/index2.vue